// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Attach extra metadata to a file upload.
 *
 * This can be used to immediately set the data_type, desription, and other metadata
 * right after the file is uploaded.
 * @export
 * @interface DescriptorCreate
 */
export interface DescriptorCreate {
  /**
   *
   */
  dataType?: string | null;
  /**
   *
   */
  description?: string;
  /**
   *
   */
  meta?: { [key: string]: any };
}

/**
 * Check if a given object implements the DescriptorCreate interface.
 */
export function instanceOfDescriptorCreate(value: object): value is DescriptorCreate {
  return true;
}

export function DescriptorCreateFromJSON(json: any): DescriptorCreate {
  return DescriptorCreateFromJSONTyped(json, false);
}

export function DescriptorCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DescriptorCreate {
  if (json == null) {
    return json;
  }
  return {
    dataType:
      json["data_type"] === undefined
        ? undefined
        : json["data_type"] === null
        ? null
        : json["data_type"],
    description: json["description"] == null ? undefined : json["description"],
    meta: json["meta"] == null ? undefined : json["meta"],
  };
}

export function DescriptorCreateToJSON(json: any): DescriptorCreate {
  return DescriptorCreateToJSONTyped(json, false);
}

export function DescriptorCreateToJSONTyped(
  value?: DescriptorCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    data_type: value["dataType"],
    description: value["description"],
    meta: value["meta"],
  };
}
